import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import axios from 'axios';
import {
  CarouselProvider,
  Slider,
  Slide,
  Image,
  ButtonBack,
  ButtonNext
} from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";

import classes from "./Carousel.module.css";
import tr from "../../assets/tr.svg";
import en from "../../assets/en.svg";
import useWindowDimensions from '../../hooks/screen-width';

const Carousel = props => {
  // const MOVIE_DATA = [
  //   {
  //     name: "Hobbs & Shaw",
  //     link: "film",
  //     nameTR: "Hobbs & Shaw",
  //     banner: "film.jpg",
  //     dublaj: 1,
  //     altyazi: 1
  //   },
  //   {
  //     name: "Ford v Ferrari",
  //     link: "film",
  //     nameTR: "Asfaltın Kralları",
  //     banner: "fordvferrari.jpg",
  //     dublaj: 1,
  //     altyazi: 1
  //   },
  //   {
  //     name: "Hobbs & Shaw",
  //     link: "film",
  //     nameTR: "Hobbs & Shaw",
  //     banner: "film.jpg",
  //     dublaj: 1,
  //     altyazi: 1
  //   },
  //   {
  //     name: "Ford v Ferrari",
  //     link: "film",
  //     nameTR: "Asfaltın Kralları",
  //     banner: "fordvferrari.jpg",
  //     dublaj: 1,
  //     altyazi: 1
  //   },
  //   {
  //     name: "Hobbs & Shaw",
  //     link: "film",
  //     nameTR: "Hobbs & Shaw",
  //     banner: "film.jpg",
  //     dublaj: 1,
  //     altyazi: 1
  //   },
  //   {
  //     name: "Ford v Ferrari",
  //     link: "film",
  //     nameTR: "Asfaltın Kralları",
  //     banner: "fordvferrari.jpg",
  //     dublaj: 1,
  //     altyazi: 1
  //   }
  // ];

  const [movieData, setMovieData] = useState([]);

  useEffect(() => {
    axios.get('https://api.themoviedb.org/3/movie/popular?api_key=d527b80849d55bcff1111f0777f4e175&language=tr-TR&page=1')
      .then(res => {
        setMovieData(res.data.results);
      });
  }, []);
  
  const { width } = useWindowDimensions();
  let slides = 0;
  if (width < 768) {
    slides = 1;
  } else {
    slides = 2;
  }

  let slide = 0;
  const movies = movieData.slice(0,6).map((movie, index) => {
    slide = slide + 1;
    let dublaj = null;
    let altyazi = null;

    if (movie.dublaj === 1) {
      dublaj = <img src={tr} alt="Türkçe" />;
    }

    if (movie.altyazi === 1) {
      altyazi = <img src={en} alt="İngilizce" />;
    }

    return (
      <Slide index={index} key={index} id={"Slide" + index}>
        <Link className={classes.Link} to={"/film/" + movie.id}>
          <div className={classes.Top}>
            <div className={classes.Lang}>
              {dublaj}
              {altyazi}
            </div>
          </div>
          <div className={classes.Bot}>
            <div className={classes.Name}>{movie.original_title}</div>
            <div className={`${classes.Name} ${classes.TR}`}>
              {movie.title}
            </div>
          </div>
          <div className={classes.ImgCover}></div>
          <Image
            hasMasterSpinner={true}
            //src={"images/banner/" + movie.banner}
            src={'http://image.tmdb.org/t/p/w780' + movie.backdrop_path}
            alt={movie.original_title + " " + movie.title}
          />
        </Link>
      </Slide>
    );
  });

  return (
    <CarouselProvider
      className={classes.Carousel}
      naturalSlideWidth={16}
      naturalSlideHeight={9}
      totalSlides={slide}
      visibleSlides={slides}
      step={1}
      infinite={false}
      isPlaying={true}
      lockOnWindowScroll={true}
    >
      <Slider>{movies}</Slider>

      <ButtonBack className={`${classes.Button} ${classes.Left}`}>
        <i className="fas fa-chevron-left"></i>
      </ButtonBack>
      <ButtonNext className={`${classes.Button} ${classes.Right}`}>
        <i className="fas fa-chevron-right"></i>
      </ButtonNext>
    </CarouselProvider>
  );
};

export default Carousel;
